import { JSX } from "react";
import Header, { IProps as IHeaderProps } from "../../Components/Layout/Header/Header";
import Sidebar from "../../Components/Layout/Sidebar/Sidebar";
import { appContext } from "../../AppContext";
import { IbssPage } from "../../Components/Core/BasePage/IbssPage";
import { Typography } from "@iconics/components";
import "./Styles.scss";

class Unauthorised extends IbssPage<IProps, IState>
{
    private labels = appContext().labels;

    public componentDidMount(): void
    {
        this.pageTitle = '';
    }

    public render(): JSX.Element
    {
        return (
            <div className="page-container">
                <Sidebar {...this.props} />
                <div className="rightPanel">
                    <Header {...this.props as unknown as IHeaderProps} />
                    <div className="redirectContainer">
                        <div className="card">
                            <Typography role="body" size="large">{this.labels.HubLabelUnauthorisedMessage}</Typography>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Unauthorised;
export interface IProps { }
export interface IState { }
